import { supabase } from '../config/supabaseClient.js';
import { formatarTitulo } from '../lib/dom.js';
import { sessao } from '../lib/auth.js';
import { operadorAtual } from '../lib/operador.js';

/** Lista itens ATIVOS + PENDENTES (usaveis no balcao). Retorna {value,label,nome,status}. */
async function listar(tabela) {
  try {
    const { data, error } = await supabase.from(tabela).select('id, nome, status').in('status', ['ATIVO', 'PENDENTE']).order('nome');
    if (error) return [];
    return (data || []).map((r) => ({ value: r.id, label: r.status === 'PENDENTE' ? `${r.nome} (aguardando aprovação)` : r.nome, nome: r.nome, status: r.status }));
  } catch { return []; }
}
export const listarMotivos = () => listar('visita_motivo');
export const listarEmpresas = () => listar('visita_empresa');

/** Cria (ou reusa, sem diferenciar maiuscula) uma entrada PENDENTE. Retorna {id, nome} ou null. */
async function criarPendente(tabela, nomeRaw) {
  const nome = formatarTitulo((nomeRaw || '').trim());
  if (!nome) return null;
  const achar = async () => {
    const padrao = nome.replace(/([\\%_])/g, '\\$1'); // escapa curingas: ilike vira match exato (case-insensitive)
    const { data } = await supabase.from(tabela).select('id, nome').ilike('nome', padrao).limit(1);
    return (data && data.length) ? { id: data[0].id, nome: data[0].nome } : null;
  };
  const existente = await achar();
  if (existente) return existente;
  const base = { nome, status: 'PENDENTE', criado_por: sessao.usuario?.id || operadorAtual.id || null };
  // grava tambem o NOME de quem sugeriu (criado_nome); degrada se a 0070 ainda nao rodou.
  let { data, error } = await supabase.from(tabela)
    .insert({ ...base, criado_nome: operadorAtual.nome || null }).select('id, nome').single();
  if (error && (/criado_nome|column|schema cache/i.test(error.message || '') || error.code === 'PGRST204' || error.code === '42703')) {
    ({ data, error } = await supabase.from(tabela).insert(base).select('id, nome').single());
  }
  if (error) return (await achar()); // corrida/duplicata: tenta reusar
  return { id: data.id, nome: data.nome };
}
export const criarMotivoPendente = (n) => criarPendente('visita_motivo', n);
export const criarEmpresaPendente = (n) => criarPendente('visita_empresa', n);

/** Lista as entradas PENDENTES (para a aba de aprovacao do gestor). Degrada sem criado_nome. */
async function listarPendentes(tabela) {
  const cols = 'id, nome, criado_nome, created_at';
  let { data, error } = await supabase.from(tabela).select(cols).eq('status', 'PENDENTE').order('created_at', { ascending: false });
  if (error && (/criado_nome|column|schema cache/i.test(error.message || '') || error.code === 'PGRST204' || error.code === '42703')) {
    ({ data, error } = await supabase.from(tabela).select('id, nome, created_at').eq('status', 'PENDENTE').order('created_at', { ascending: false }));
  }
  if (error) { console.error('[visita pendentes]', error.message); return []; }
  return data || [];
}
export const listarMotivosPendentes = () => listarPendentes('visita_motivo');
export const listarEmpresasPendentes = () => listarPendentes('visita_empresa');

/** Conta itens PENDENTES (badge do menu). Degrada para 0 se a tabela ainda nao existe. */
async function contarPendentes(tabela) {
  try {
    const { count, error } = await supabase.from(tabela).select('*', { count: 'exact', head: true }).eq('status', 'PENDENTE');
    return error ? 0 : (count || 0);
  } catch { return 0; }
}
export const contarMotivosPendentes = () => contarPendentes('visita_motivo');
export const contarEmpresasPendentes = () => contarPendentes('visita_empresa');